// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__26Anj","header":"PatientBlock_header__3e0Cs","label":"PatientBlock_label__246VF","option":"PatientBlock_option__AhyB7"};